const getDivision = (rating, isClassifiedAsPro = false, isFemale = false) => {
  if (isFemale) {
    if (rating >= 900 || isClassifiedAsPro) return 'FPO';
    else if (rating >= 825) return 'FA1';
    else if (rating >= 775) return 'FA2';
    else if (rating >= 725) return 'FA3';
    return 'FA4';
  }
  if (rating >= 970 || isClassifiedAsPro) return 'MPO';
  else if (rating >= 935) return 'MA1';
  else if (rating >= 900) return 'MA2';
  else if (rating >= 850) return 'MA3';
  return 'MA4';
};

export {getDivision};
